import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getBulletinList } from "../api/getBulletinList";

export const useBulletinListQuery = () => {
  return useQuery({
    queryKey: ["bulletins"],
    queryFn: getBulletinList,
  });
};

export const invalidateBulletinListQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: ["bulletins"],
  });
};
